export default {
      id: "configurator-usage",
      viewBox: "0 0 79 53",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#configurator",
      toString: function () {
        return this.url;
      }
    }